<template>
  <div class="d-flex-column justify-start align-start gap-20">
    <div class="d-flex-column justify-start align-start gap-5">
      <h4 class="t-white font-family-1 title-h5 f-w-600">
        {{ $t("path_of_exile.campaign_acts") }}
      </h4>
      <p class="t-grey font-family-2 regular-l">
        {{ $t("path_of_exile.select_extra_divine_orbs") }}
      </p>
    </div>
    <div
      class="act_picker_container d-flex-column justify-start align-start gap-18 b-radius-12"
    >
      <div class="d-flex-row space-between">
        <button
          class="role_picker other b-radius-9 medium-l font-family-2 flex-5 full-width"
          @click.stop="selectActType('specific_act')"
          :class="[selectedAct === 'specific_act' && 'selected']"
        >
          {{ $t("path_of_exile.specific_acts") }}
        </button>
        <button
          class="role_picker gap-3 other b-radius-9 medium-l font-family-2 flex-5 full-width"
          v-if="allAct"
          @click.stop="selectActType('all_acts')"
          :class="[selectedAct === 'all_acts' && 'selected']"
        >
          {{ $t("path_of_exile.all_acts") }}
          <span class="t-blue">
            +{{ userStore.getUserCurrencyCode }}{{ allAct.price }}
          </span>
        </button>
      </div>

      <div
        class="act_type_picker b-radius-12"
        v-if="selectedAct === 'specific_act'"
      >
        <button
          class="role_picker d-flex-row justify-start gap-5 medium-l font-family-2"
          v-for="option in specficActs"
          :key="option"
          @click.stop="setActType(option)"
          :class="[isOptionSelected(option.id) && 'selected']"
        >
          <Checkbox
            :is-checked="isOptionSelected(option.id)"
            type="other"
            variant="secondary"
            :emit-function="emitTrial"
            :selectable-value="option"
            :emit-function-key="'trial'"
          />
          {{ option.title }}
          <span class="t-blue"> {{ renderPrice(option) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import Checkbox from "~/components/custom/Checkbox.vue";

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();
const userStore = useUserStore();
const selectedAct = ref("specific_act");

const selectActType = (type) => {
  selectedAct.value = type;
};
const specficActs = computed(() => {
  return gameStore.getGamePack.prices?.filter(
    (price) => price.title !== "All Acts"
  );
});
const allAct = computed(() => {
  return gameStore.getGamePack.prices?.find(
    (price) => price.title === "All Acts"
  );
});

const renderPrice = (packOption) => {
  return `+${userStore.getUserCurrencyCode}${parseFloat(packOption.price).toFixed(2)}`;
};

const isOptionSelected = (packOption) => {
  if (!checkoutStore.getDetails?.acts) return false;
  const selectedOption = checkoutStore.getDetails?.acts?.find(
    (act) => act.id === packOption
  );
  if (!selectedOption) {
    return false;
  }
  return true;
};
const setActType = (option) => {
  const otherOptions =
    checkoutStore.getDetails?.acts?.filter((act) => act.id !== option.id) || [];

  if (!isOptionSelected(option.id)) {
    checkoutStore.setDetails({
      acts: [...otherOptions, { id: option.id, title: option.title }],
    });
  } else if (checkoutStore.getDetails?.acts?.length > 1) {
    checkoutStore.setDetails({
      acts: [...otherOptions],
    });
  }
};
const emitTrial = (key, value) => {
  setActType(value);
};

watch(selectedAct, (newVal) => {
  if (newVal === "specific_act") {
    const firstAct = specficActs.value[0];
    checkoutStore.setDetails({
      acts: [
        {
          id: firstAct.id,
          title: firstAct.title,
        },
      ],
    });
  } else if (newVal === "all_acts") {
    checkoutStore.setDetails({
      acts: [
        {
          id: allAct.value?.id,
          title: allAct.value?.title,
        },
      ],
    });
  }
});
</script>

<style lang="scss" scoped>
.act_picker_container {
  padding: 12px;
  border: 1px solid var(--stroke-dark);
}

.act_type_picker {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(auto, 1fr);
  grid-column-gap: 12px;
  grid-row-gap: 12px;
  padding: 12px;
  border: 1px solid var(--stroke-dark);

  @media screen and (max-width: 1440px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
